import { defineComponent as _defineComponent } from 'vue'
import {ref, watch} from 'vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'

interface Props {
  field: {
    isRadio: boolean,
    uniqueKey: () => string
  }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BooleanFieldSettings',
  props: {
    field: null
  },
  emits: ["modify-field"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'modify-field', payload: {propertyKey: string, fieldValue: boolean, key: string}) : void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  field: {
    isRadio: boolean,
    uniqueKey: () => string
  }
}





const activeToggleType = ref(props.field.isRadio ? 'radio' : 'checkbox')

watch(() => props.field.isRadio, (newIsRadio) => {
  activeToggleType.value = newIsRadio ? 'radio' : 'checkbox'
}, { immediate: true })
 
function changeToggleType() {
  emit('modify-field', {
    propertyKey: 'isRadio',
    fieldValue: activeToggleType.value === 'radio',
    key: props.field.uniqueKey()
  })
}

return { __sfc: true,props, emit, activeToggleType, changeToggleType, VsWrapper }
}

})